import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disable",
  "use": "icon-disable-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-disable\"><path d=\"M512 36.571429a475.428571 475.428571 0 1 1 0 950.857142 475.428571 475.428571 0 0 1 0-950.857142z m305.590857 228.059428l-552.96 552.96a393.142857 393.142857 0 0 0 552.96-552.96zM512 118.857143a393.142857 393.142857 0 0 0-305.590857 640.512l552.96-552.96A391.533714 391.533714 0 0 0 512 118.857143z\" p-id=\"8484\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol